module.exports = __webpack_public_path__ + "img/icono-zip.98a17967.svg";